import React from 'react'
import { useState, useEffect } from 'react'
import axios from "axios";
import { FaTimes } from 'react-icons/fa';
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
// import { AiOutlinePlusCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom'

const Employee = () => {

    const [detail, setDetail] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        short_name: '',
        fax: '',
        url: '',
        pan: '',
        gst: '',
        esic_no: '',
        esic_acct: '',
        bank_name: '',
        esic_office: '',
        acc_no: '',
        pf_no: '',
        ifsc: '',
        pincode: '',
        aadhaar: '',
        bill: ''
    });

    const [files, setFiles] = useState({
        gst_img: null,
        pan_img: null,
        bill_img: null,
        aadhaar_front: null,
        aadhaar_back: null,
    });
    const navigate = useNavigate()



    useEffect(() => {
        const fecthDetail = async () => {
            try {
                const resDetail = await axios.get('https://api.skyguard.group/api/fetch-admin-employee');
                setDetail(resDetail.data.result);
            } catch (error) {
                console.log(error)
            }
        };
        fecthDetail();
    }, []);


    const handleFileChange = (e) => {
        setFiles({ ...files, [e.target.name]: e.target.files[0] });
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // append text fields
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });

        // append files
        Object.keys(files).forEach((key) => {
            if (files[key]) {
                formData.append(key, files[key]);
            }
        });

        try {
            const res = await axios.post(
                "https://api.skyguard.group/api/add-employee",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            console.log("✅ Success:", res.data);
             setTimeout(() => {
    window.location.reload();
  }, 3000);
            alert("Employee added successfully!");
        } catch (error) {
            console.error("❌ Error:", error.response?.data || error.message);
            alert("Error adding company");
        }
    };



    const handleDelete = async (id) => {
        // if (!window.confirm("Are you sure you want to delete this employee?")) return;

        try {
            const res = await axios.delete(`https://api.skyguard.group/api/delete-employee/${id}`);
            setTimeout(() => {
    window.location.reload();
  }, 1000);
        } catch (err) {
            console.error(err);
         
        }
    };

    const handleEdit = (employee) => {
        navigate('/admin/edit-emp', { state: { employee } });
    }

const openDeletePopup = (id) => {
  setDeleteId(id);
  setShowPopup(true);
};

// Confirm delete
const confirmDelete = () => {
  if (deleteId) {
    handleDelete(deleteId); // pass the stored ID
    setShowPopup(false);
    setDeleteId(null);
  }
};


    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Employee</h3>
                <div className='mb-2 d-flex justify-content-between'>
                    <input
                        className="form-control w-50"
                        list="datalistOptions"
                        id="exampleDataList"
                        placeholder="Search by Employee Name..."
                    />



                    <button
                        className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                        onClick={() => {
                            setShowForm(!showForm);

                        }}
                    >
                        {showForm ? (
                            <>
                                Close <FaTimes size={20} />
                            </>
                        ) : (
                            <>
                                Add Branch  <AiOutlinePlusCircle size={22} />
                            </>
                        )}
                    </button>

                    {/* <button className='btn btn-success'>Add <AiOutlinePlusCircle size={20} /></button> */}
                </div>


                {showForm && (


                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>

                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={form.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="email" placeholder="Email" value={form.email} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={form.phone} onChange={handleInputChange} />
                                </div>

                                <div className="col-md-4">
                                    <input type="password" className="form-control" name="password" placeholder="Password" value={form.password} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="address" placeholder="address" value={form.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="city" placeholder="city" value={form.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="state" placeholder="state" value={form.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={form.pincode} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="short_name" placeholder="Short Name " value={form.short_name} onChange={handleInputChange} />
                                </div>










                                <h5 className="mt-4">Bank Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="bank_name" placeholder="Bank Name" value={form.bank_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="acc_no" placeholder="Account Number" value={form.acc_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="branch" placeholder="Branch" value={form.branch} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="ifsc" placeholder="IFSC" value={form.ifsc} onChange={handleInputChange} />
                                    </div>


                                </div>

                                <h5 className="mt-4">ESIC Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_no" placeholder="ESIC Number" value={form.esic_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_acct" placeholder="ESIC Acctount" value={form.esic_acct} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_office" placeholder="ESIC Office" value={form.esic_office} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Pan Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Pan</label>
                                        <input type="text" className="form-control" name="pan" placeholder="Pan" value={form.pan} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Pan</label>
                                        <input type="file" className="form-control" name="pan_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                </div>
                                <h5 className="mt-4">Aadhar Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Aadhaar Number</label>
                                        <input type="text" className="form-control" name="aadhaar" placeholder="Aahaar Number" value={form.aadhaar} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Front Aadhaar Image</label>
                                        <input type="file" className="form-control" name="aadhaar_front" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload Your Back Aadhaar Image</label>
                                        <input type="file" className="form-control" name="aadhaar_back" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="pf_no" placeholder="PF Number" value={form.pf_no} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={form.fax} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="url" placeholder="URL" value={form.url} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Enter Your GST Number</label>
                                        <input type="text" className="form-control" name="gst" placeholder="GST" value={form.gst} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label" > Upload Your GST image or pdf</label>

                                        <input type="file" className="form-control   " name="gst_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Enter Your Light Bill</label>
                                        <input type="text" className="form-control" name="bill" placeholder="Enter Your Light Bill" value={form.bill} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Light Bill</label>
                                        <input type="file" className="form-control" name="bill_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                </div>








                                {/* <div className="col-md-4">


                                </div> */}
                                <div className="col-md-12 text-end">
                                    <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                )}



                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th>SN</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th> City </th>
                                <th scope='col'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {detail.map((employee, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{employee.name}</td>
                                    <td>{employee.phone}</td>
                                    <td>{employee.email}</td>
                                    <td>{employee.city}</td>
                                    <td>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => handleEdit(employee)}
                                        >
                                            Edit
                                        </button>
                                        &nbsp;

                                        {/* <button
                                              className="btn btn-danger"
                                              onClick={() => handleDelete(employee.id)}
                                            >
                                              <AiOutlineDelete size={20} />
                                            </button> */}
                                       <button
      className="btn btn-danger"
      onClick={() => openDeletePopup(employee.id)} // ✅ pass emp.id when opening popup
    >
      <AiOutlineDelete size={20} />
    </button>
                                    </td>

                                </tr>



                 
                            ))}
                        </tbody>

                       {showPopup && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirm Delete</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowPopup(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this employee?</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowPopup(false)}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={confirmDelete}>
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
)}

                    </table>
                </div>
            </div>
        </div>
    )
}

export default Employee